module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Mic-5138d25b023abbec96e2fd94b722f570.svg";